import {
  bemeCell, createdCell,
  dateCell,
  descriptionCell, emotionCell, extensionCell, folderNameCell,
  formatItemDataType,
  iconCell, keywordsCell, locationCell,
  nameCell, peopleCell,
  selectCell, sizeCell, sourceCell,
  statusCell, updatedCell
} from "../list-view/ItemCells";

export const makeDefaultFilterDefinitions = () => [
  { label: "Status", key: "status", enabled: true, visible: true, options: (opts) => [{name:'Active', value: 1}, {name: 'Pending', value: 0}] },
  { label: "Keywords", key: "keywords", enabled: true, visible: true, options: (opts) => opts ? (opts.keywords || []).map((k) => ({value: k.id, name: k.text})) : [] },
  { label: "People", key: "people", enabled: true, visible: true, options: (opts) => opts ? (opts.people || []).map((p) => ({value: p.id, name: p.name})) : [] },
  { label: "Folders", key: "folders", enabled: true, visible: true, options: (opts) => opts ? (opts.folders || []).map((f) => ({value: f.id, name: f.name})) : [] },
  { label: "Emotions", key: "emotions", enabled: true, visible: true, options: (opts) => opts ? (opts.emotions || []).map((e) => ({value: e, name: e})) : [] },
  { label: "Bemes", key: "bemes", enabled: true, visible: true, options: (opts) => opts ? (opts.bemes || []).map((e) => ({value: e, name: e})) : [] },
  { label: "Item Types", key: "item_data_types", enabled: true, visible: true, options: (opts) => opts ? (opts.item_data_types || []).map((e) => ({value: e, name: formatItemDataType(e)})) : [] },
  { label: "File Type", key: "upload_types", enabled: true, visible: true, options: (opts) => opts ? (opts.upload_types || []).map((e) => ({value: e, name: e})) : [] }
];

export const makeDefaultColumns = (addFilterSelectByName) => [
  {key: 'selected', header: {label: '', sort: null }, cell: selectCell, enabled: true},
  {key: 'type', header: [
      { label: 'Type', sort: 'mindfile_items.item_data_type' },
      { label: 'Status', sort: 'mindfile_items.status', asc: false },
    ], cell: statusCell, enabled: true },
  {key: 'icon', header: {label: '', sort: null }, cell: iconCell, enabled: true },
  {key: 'name', header: { label: 'Name', sort: 'mindfile_items.name' }, cell: nameCell, enabled: true },
  {key: 'description', header: { label: 'Description', sort: 'mindfile_items.description', nulls: true }, cell: descriptionCell, enabled: true },
  {key: 'date', header: { label: 'Date', sort: 'mindfile_items.date', asc: false, nulls: true }, cell: dateCell, enabled: true },
  {key: 'location', header: [
      { label: 'Location', sort: 'locations.country', nulls: true },
      {label:'Latitude', shortLabel: 'Lat', sort: 'locations.latitude', nulls: true },
      {label:'Longitude', shortLabel: 'Lng', sort: 'locations.longitude', nulls: true },
    ], cell: locationCell, enabled: true },
  {key: 'keywords', header: { label: 'Keywords', sort: 'keywords.text', asc: false, nulls: true }, cell: keywordsCell, enabled: true, action: (id) => addFilterSelectByName('Keywords', id)},
  {key: 'people', header: { label: 'People', sort: 'people.name', asc: false, nulls: true }, cell: peopleCell, enabled: true, action: (id) => addFilterSelectByName('People', id) },
  {key: 'emotion', header: { label: 'Emotion', sort: 'mindfile_items.emotion', nulls: true }, cell: emotionCell, enabled: true, action: (emot) => addFilterSelectByName('Emotions', emot) },
  {key: 'beme', header: { label: 'Beme', sort: 'mindfile_items.beme', nulls: true }, cell: bemeCell, enabled: true, action: (beme) => addFilterSelectByName('Bemes', beme) },
  {key: 'created', header: { label: 'Added', sort: 'mindfile_items.created_at', asc: false }, cell: createdCell, enabled: true },
  {key: 'updated', header: { label: 'Modified', sort: 'mindfile_items.updated_at', asc: false }, cell: updatedCell, enabled: true },
  {key: 'extension', header:  {label:'Extension', shortLabel: 'Ext', sort: 'uploads.extension', nulls: true }, cell: extensionCell, enabled: true, hidden: true },
  {key: 'size', header: { label: 'Size', sort: 'uploads.size', asc: false, nulls: true }, cell: sizeCell, enabled: true, hidden: true },
  {key: 'source', header: { label: 'Source', sort: 'uploads.source', nulls: true }, cell: sourceCell, enabled: true, hidden: true },
  {key: 'folderName', header: { label: 'Folder', sort: 'folders.name' }, cell: folderNameCell, enabled: true, action: true },
];

export const makeFilters = (filterDefinitions, handleFilterSelect, addFilterSelect) => filterDefinitions.map((filter, index) => ({
  ...filter, index: index, handleSelect: handleFilterSelect.bind(this, index), addFilterSelect: addFilterSelect.bind(this, index)
}));

export const makeDefaultColumnSelection = (columns) => {
  const obj = Object.assign({}, ...columns.filter(col => col.enabled).map(c => ({[c.key]: !c.hidden})))
  return obj;
};

export const makeDefaultViewOpts = (columns) => ({
  rowsPerPage: 12,
  orders: [{f: 'mindfile_items.updated_at', d: false, n: true}],
  viewMode: 'List',
  visibleColumns: makeDefaultColumnSelection(columns)
});

export const makeDefaultFilters = () => [
  { key: "status", selectedItems: [], },
  { key: "keywords", selectedItems: [], },
  { key: "people", selectedItems: [], },
  { key: "folders", selectedItems: [], },
  { key: "emotions", selectedItems: [], },
  { key: "bemes", selectedItems: [], },
  { key: "item_data_types", selectedItems: [], },
  { key: "upload_types", selectedItems: [], },
  { key: "sources", selectedItems: [], },
    { key: "survey_names", selectedItems: [], },
    { key: "survey_complete", selectedItems: [], },
];


// constructor(props) {
//   super(props);
//   this.filterDefinitions = makeDefaultFilterDefinitions();
//   this.columns = makeDefaultColumns(this.addFilterSelectByName.bind(this));
//   this.filters = makeFilters(this.filterDefinitions, this.handleFilterSelect.bind(this), this.addFilterSelect.bind(this));
//   this.defaultViewOpts = makeDefaultViewOpts(this.columns);
//   this.defaultFilters = makeDefaultFilters;
//   this.state = {
//     pageKey: "/explore/items",
//     title: "All Mindfile Items",
//     loading: true,
//     viewOptsLoaded: false,
//     controller: {
//       page: 1,
//       rowsPerPage: this.defaultViewOpts.rowsPerPage,
//       orders: this.defaultViewOpts.orders,
//       search: null,
//     },
//     items: [],
//     filter_count: 0,
//     folderList: [],
//     filterSelections: this.defaultFilters(),
//     selectedIds: [],
//     tableView: {
//       addButtons: ['Upload', 'Link', 'Favorite', 'JournalPost'],
//       viewMode: this.defaultViewOpts.viewMode,
//       viewModeOptions: ['List', 'Icon', 'Stream'],
//       filtersOpen: false,
//       columnsOpen: false,
//       visibleColumns: this.defaultViewOpts.visibleColumns
//     },
//   };
// }